import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DecodeXmlPipe } from './decode-xml.pipe';

@NgModule({
    declarations: [DecodeXmlPipe],
    imports: [
        CommonModule
    ],
    exports: [DecodeXmlPipe]
})
export class DecodeXmlModule { }
